
import React from 'react';
import { Users, RefreshCcw } from 'lucide-react';
import { CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { InviteLinkShare } from '@/components/travel/InviteLinkShare';

interface TravelersHeaderProps {
  isAuthorized: boolean;
  onRefresh: () => void;
  onInvite: () => void;
  tripId: string;
}

export const TravelersHeader: React.FC<TravelersHeaderProps> = ({ 
  isAuthorized, 
  onRefresh, 
  onInvite,
  tripId
}) => {
  return (
    <div className="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center">
        <Users className="h-5 w-5 mr-2 text-glowingTeal" />
        <CardTitle className="text-lg">Trip Travelers</CardTitle>
      </div>
      <div className="flex flex-wrap gap-2">
        {isAuthorized && (
          <InviteLinkShare tripId={tripId} />
        )}
        <Button 
          variant="outline" 
          size="sm"
          onClick={onRefresh}
          className="text-xs"
        >
          <RefreshCcw className="h-3.5 w-3.5 mr-1" />
          Refresh
        </Button>
      </div>
    </div>
  );
};
